// extracted by mini-css-extract-plugin
export default {"unpausebutton":"pause_unpausebutton__xFBJF","pausetext":"pause_pausetext__B+TMv","logo":"pause_logo__emUrf","alldetails":"pause_alldetails__y-zPh"};